<template>
  <div>
    <!-- 日付指定検索 -->
    <div class="column">
      <div class="field control">
        <label class="label">登録日指定</label>
        <div class="control">
          <flat-pickr v-model="daterange.from" class="input" :config="config.from"></flat-pickr>
        </div>
      </div>
      ～
      <div class="field control">
        <div class="control">
          <flat-pickr v-model="daterange.to" class="input" :config="config.to"></flat-pickr>
        </div>
      </div>
    </div>
    <!-- 緊急性検索 -->
    <div class="column">
      <div class="field control">
        <label class="label">緊急性</label>
        <div class="select">
          <select v-model="search_params.fk_urgency">
            <option v-for="urgency in urgencys" v-bind:key="urgency.id" v-bind:value="urgency.id">
              {{ urgency.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- 登録者 -->
    <div class="column">
      <div class="field control">
        <label class="label">登録者</label>
        <div class="select">
          <select v-model="search_params.fk_register_id">
            <option v-for="register in registers" v-bind:key="register.id" v-bind:value="register.id">
              {{ register.dispname }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- 担当者 -->
    <div class="column">
      <div class="field control">
        <label class="label">担当者</label>
        <div class="select">
          <select v-model="search_params.fk_rep_id">
            <option v-for="rep in reps" v-bind:key="rep.id" v-bind:value="rep.id">
              {{ rep.dispname }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- ステータス検索 -->
    <div class="column">
      <div class="field control">
        <label class="label">ステータス</label>
        <div class="select">
          <select v-model="search_params.fk_status_id">
            <option v-for="status in statuses" v-bind:key="status.id" v-bind:value="status.id">
              {{ status.dispname }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="column">
      <button class="button is-link is-rounded" @click="getTaskData" v-bind:disabled="!isToggleActive">検  索</button>
      <button class="button is-rounded" @click="clearTaskData" v-bind:disabled="!isToggleActive">クリア</button>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { TASK_STATUS } from '../util.js'

export default {
  data: function(){
    return {
      config:{
        from: {
          locale: Japanese,
          static: true,
          altInput: false,
          altFormat: 'YYYY-MM-DD',
          maxDate: null,
        },
        to: {
          locale: Japanese,
          static: true,
          altInput: false,
          altFormat: 'YYYY-MM-DD',
          minDate: null
        }
      },
      search_params:{
        fk_urgency: '',
        fk_status_id: '',
        fk_mode: '',
        fk_register_id: '',
        fk_rep_id: '',
        mapshow: 1,
      },
      statuses: TASK_STATUS
    }
  },
  components:{
    flatPickr,
  },
  props:{
    daterange:{
    type: Object,
    default: () =>({
        to: '',
        from: '',
      })
    },
    isToggleActive:{
      type: Boolean,
      default: () => false
    },
  },
  computed: {
    ...mapGetters({
      urgencys: 'item/urgencys',
      registers: 'item/users',
      reps: 'item/users',
    })
  },
  watch:{
    'daterange.from': function(val){
      this.$set( this.config.to, 'minDate', val) 
    },
    'daterange.to': function(val){
      this.$set(this.config.from, 'maxDate', val)
    },
  },
  mounted(){
    this.$set(this.daterange, 'from', this.daterange.from)
    this.$set(this.daterange, 'to', this.daterange.to)
    this.$store.dispatch('item/getItems', {})
  },
  methods:{
    clearTaskData(){
      let today = moment().format("YYYY-MM-DD");
      //初期化
      Object.keys(this.search_params).forEach((key) => {
        this.$set(this.search_params, key, '')
      })
      this.$set(this.daterange, 'from', moment(today).add(-1, 'W').format("YYYY-MM-DD"))  //1ヶ月前からデータに絞り込み
      this.$set(this.daterange, 'to', today)
      this.$emit('getSearch',[this.search_params,this.daterange])
    },
    getTaskData(){
      //検索
      this.$emit('getSearch',[this.search_params,this.daterange])
    },
  },
}
</script>